import { render } from "./ProviderForm.vue?vue&type=template&id=7462322a"
import script from "./ProviderForm.vue?vue&type=script&lang=js"
export * from "./ProviderForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__